import React from "react";
import { loadedImagesCache } from "../../utils/imageLoadCache";
import "./ChatImageComponents.css";

// Custom properties don't get React's automatic "px" suffix.
const cssSize = (v) => (typeof v === "number" ? `${v}px` : v);

export { loadedImagesCache };

export const ImageWithLoading = React.memo(({
  src,
  imageStyle,
  isPortrait,
  squareSize,
  calculatedWidth,
  calculatedHeight,
  maxHeight,
  minWidth,
  minHeight,
  onClick,
  onError
}) => {
  const [isImageLoaded, setIsImageLoaded] = React.useState(() => loadedImagesCache.has(src));
  const [hasImageError, setHasImageError] = React.useState(false);

  React.useEffect(() => {
    if (loadedImagesCache.has(src)) {
      setIsImageLoaded(true);
      setHasImageError(false);
    } else {
      setIsImageLoaded(false);
      setHasImageError(false);
    }
  }, [src]);

  const placeholderWidth = isPortrait ? squareSize : calculatedWidth;
  const placeholderHeight = calculatedHeight || (isPortrait ? squareSize : minHeight) || 200;

  return (
    <div
      className="chat-image-gallery chat-image-components__frame"
      style={{
        "--chat-image-w": cssSize(placeholderWidth),
        "--chat-image-h": cssSize(placeholderHeight),
      }}
    >
      {!isImageLoaded && !hasImageError && (
        <div className="chat-image-components__placeholder" />
      )}
      <img
        loading="lazy"
        decoding="async"
        onClick={onClick}
        className={`chat-image-components__image${isImageLoaded ? ' chat-image-components__image--loaded' : ''}`}
        style={imageStyle}
        src={src}
        alt=""
        onLoad={() => {
          loadedImagesCache.add(src);
          setIsImageLoaded(true);
        }}
        onError={(e) => {
          loadedImagesCache.delete(src);
          setHasImageError(true);
          setIsImageLoaded(false);
          if (onError) onError(e);
        }}
      />
    </div>
  );
});

ImageWithLoading.displayName = 'ImageWithLoading';

export const GalleryImage = React.memo(({ src, style, borderRadius, onClick, overlay }) => {
  const [isLoaded, setIsLoaded] = React.useState(() => loadedImagesCache.has(src));
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    if (loadedImagesCache.has(src)) {
      setIsLoaded(true);
      setHasError(false);
    } else {
      setIsLoaded(false);
      setHasError(false);
    }
  }, [src]);

  return (
    <div
      className="chat-image-components__tile"
      style={{
        "--chat-image-radius": cssSize(borderRadius),
        ...style
      }}
      onClick={onClick}
    >
      {!isLoaded && !hasError && (
        <div className="chat-image-components__tile-placeholder" />
      )}
      <img
        loading="lazy"
        decoding="async"
        className={`chat-image-components__tile-image${isLoaded ? " chat-image-components__tile-image--loaded" : ""}`}
        src={src}
        alt=""
        onLoad={() => {
          loadedImagesCache.add(src);
          setIsLoaded(true);
        }}
        onError={() => {
          loadedImagesCache.delete(src);
          setHasError(true);
        }}
      />
      {overlay}
    </div>
  );
});

GalleryImage.displayName = 'GalleryImage';
